
export function dateToDateObj(date) {
  return new Date(`${date}`.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3'))
}

export function dateObjToDateStr(dateObj, linkStr = '-') {
  const year = dateObj.getFullYear()
  const month = (dateObj.getMonth() + 1).toString().padStart(2, '0')
  const day = dateObj.getDate().toString().padStart(2, '0')
  return `${year}${linkStr}${month}${linkStr}${day}`
}

export function dateObjToDatetimeStr(dateObj, linkStr) {
  return `${dateObjToDateStr(dateObj, linkStr)} ${dateObj.toTimeString().split(' ')[0]}`
}

export function dateObjToDate(dateObj) {
  return dateObjToDateStr(dateObj).split('-').join('')
}

export function dateToDateStr(date, linkStr = '-') {
  return dateObjToDateStr(dateToDateObj(date), linkStr)
}

export function traceBackDays(startObj, backDays) {
  return new Date(startObj.getTime() - backDays * 86400000)
}
